import { MAIN_HEADER_HEIGHT_PX } from "@/toggle-ui-kit/main-header";
import type { CSSProperties, ReactNode } from "react";

/**
 * 상단 바가 있는 앱 페이지의 껍데기 (dsd-editor 의 DsdEditorPageShell 과 구분). 상단 바 아래에 children 을 세로로 쌓고,
 * `--main-header-height` 를 내려보낸다. shadcn 사이드바 wrapper(`DocumentSidebar`)가
 * 이 변수만큼 `top` 을 내려 상단 바를 덮지 않는다 — 변수가 없는 페이지는 0 으로 동작.
 */
export const AppPageShell = ({
  header,
  children,
}: {
  header: ReactNode;
  children: ReactNode;
}) => (
  <div
    className="flex h-full min-h-0 flex-col"
    style={
      { "--main-header-height": `${MAIN_HEADER_HEIGHT_PX}px` } as CSSProperties
    }
  >
    {header}
    {children}
  </div>
);
